<template lang="pug">
section#in
    .in.text-white.d-flex
        .row.w-100.align-self-center
            .col-1
            .col-10.mt-5.text-uppercase.text-center
                h4.in-title {{ title }}
            .col-1
            .col-1
            .col-10.my-5.text-center
                span#in-desc.text-center.font-weight-light {{ desc }}
            .col-1

    .in-cards
        .row
            .col-1
            .col-10.mt-5.mb-3.d-column.d-sm-flex.justify-content-center
                oc-in-card(v-for='(ins,idx) in instructors' :key='idx' :cardContent='ins' )
            .col-1

                          
</template>

<script>
import OcInCard from '@/components/landing/instructors/InCard'

export default {
    components: {
        OcInCard
    },
    data () {
        return {
            title: 'Nuestros Instructores',
            desc: 'Conoce a nuestro equipo de instructores, capacitados y certificados para brindarte el apoyo en la transformación de tu vida.',
            instructors: [
                {
                    imgSrc: `${HOMEURL}img/in/list/monica.jpg`,
                    name: 'Laura Mónica Delgado Morales',
                    place: 'Ciudad Satélite',
                    teachs: 'Certificada en Lectura del Inconsciente',
                    phone: '5567277472'
                },
                {
                    imgSrc: `${HOMEURL}img/in/list/laura.jpg`,
                    name: 'Laura Sánchez Flores',
                    place: 'San Luis Potosí',
                    teachs: 'Certificada en Ortografía Cerebral',
                    phone: '4442080453'
                }
            ]
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/landing/Instructors.vue